<script>
  import {
    EVENT_STATE_PRE,
    EVENT_STATE_LIVE,
    EVENT_STATE_POST,
    STREAM_TYPE_VOD,
    STREAM_STATUS_UNAVAILABLE_EARLY,
    STREAM_STATUS_ACTIVE,
    STREAM_STATUS_UNAVAILABLE_EXPIRED,
  } from '../js/constants.js';
  import { eventState, streamState } from '../js/state.js';
  import Bowser from 'bowser';
  import LiveIndicator from './LiveIndicator.svelte';

  export let title = '...',
    onResize = (w, h) => {},
    venue = '...',
    tipJarButtons = [],
    tipJarTitle = '',
    live = false;

  let vw = 0,
    vh = 0,
    bowser = Bowser.parse(window.navigator.userAgent);

  $: onResize(vw, vh);
</script>

<div class="event-details" bind:clientWidth={vw} bind:clientHeight={vh}>
  {#if live && bowser.platform.type === 'mobile'}
    <div class="live-indicator-wrapper">
      <LiveIndicator floating={false} />
    </div>
  {/if}
  <div class="event-title-area">
    <span class="title-text">{title || ''}</span>
    {#if tipJarButtons && tipJarButtons.length > 0}
      <div class="tip-jar">
        <span class="tip-jar-title">{tipJarTitle || ''}</span>
        <div class="tip-jar-buttons-wrap">
          {#each tipJarButtons as button}
            <a href={button.url} target="_blank" class="btn tip-jar-button">{button.title}</a>
          {/each}
        </div>
      </div>
    {/if}
  </div>
  <div class="subtitle">{venue || ''}</div>

  <div class="event-description">
    {#if $streamState.type === STREAM_TYPE_VOD}
      {#if $streamState.state === STREAM_STATUS_UNAVAILABLE_EARLY}
        {@html $eventState.description_pre || $eventState.description || ''}
      {:else if $streamState.state === STREAM_STATUS_ACTIVE}
        {@html $eventState.description_active || $eventState.description || ''}
      {:else if $streamState.state === STREAM_STATUS_UNAVAILABLE_EXPIRED}
        {@html $eventState.description_post || $eventState.description || ''}
      {:else}
        {@html $eventState.description || ''}
      {/if}
    {:else if $eventState.state === EVENT_STATE_PRE}
      {@html $eventState.description_pre || $eventState.description || ''}
    {:else if $eventState.state === EVENT_STATE_LIVE}
      {@html $eventState.description_active || $eventState.description || ''}
    {:else if $eventState.state === EVENT_STATE_POST}
      {@html $eventState.description_post || $eventState.description || ''}
    {:else}
      {@html $eventState.description || ''}
    {/if}
  </div>
</div>
